import { db } from "../../plugins/firebase";

export const contracts = {
  namespaced: true,
  state: {
    contracts: [],
    contractsListener: null
  },
  getters: {
    contracts(state) {
      return state.contracts;
    },
    contract(state) {
      return id => {
        return state.contracts.find(c => c.id === id);
      };
    }
  },
  mutations: {
    setContracts(state, contracts) {
      state.contracts = contracts;
    },
    addContract(state, contract) {
      if (contract == null) {
        return;
      }
      state.contracts.push(contract);
    },
    updateContract(state, contract) {
      if (contract == null) {
        return;
      }
      state.contracts = state.contracts.map(c =>
        c.id === contract.id ? contract : c
      );
    },
    deleteContract(state, contractId) {
      state.contracts = state.contracts.filter(c => c.id !== contractId);
    },
    async setContractsListener(state, listener) {
      if (!listener && state.contractsListener) {
        // unsub
        await state.contractsListener();
      }

      state.contractsListener = listener;
    }
  },
  actions: {
    async load({ rootState, commit }) {
      await commit("setContractsListener", null);
      commit("setContracts", []);

      if (!rootState.auth.auth) {
        return;
      }

      const uid = rootState.auth.auth.uid;

      const listener = db
        .collection("contracts")
        .where("admin", "array-contains-any", [uid])
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              commit("addContract", {
                id: change.doc.id,
                name: change.doc.data().name,
                admin: change.doc.data().admin,
                standardAgendas: change.doc.data().standardAgendas,
                standardDecisions: change.doc.data().standardDecisions
              });
            }
            if (change.type === "modified") {
              commit("updateContract", {
                id: change.doc.id,
                name: change.doc.data().name,
                admin: change.doc.data().admin,
                standardAgendas: change.doc.data().standardAgendas,
                standardDecisions: change.doc.data().standardDecisions
              });
            }
            if (change.type === "removed") {
              commit("deleteContract", change.doc.id);
            }
          });
        });

      await commit("setContractsListener", listener);
    }
  }
};
